import { TasksActionTypes, TasksState, READ_TASKS_DATA_REQUEST, READ_TASKS_DATA_SUCCESS, READ_TASKS_DATA_FAILURE } from "store/reducers/types/dashboard/tasks";

const defaultState: TasksState = {
  isLoading: false,
  errorMessage: ""
};

export default function tasks(state = defaultState, action: TasksActionTypes): TasksState {
  switch (action.type) {
    case READ_TASKS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_TASKS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_TASKS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
